import { Box, TextField, InputAdornment, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { SearchSharp, Close, FilterListOff } from '@mui/icons-material';
import { useState, useEffect, useMemo } from 'react';

AGGridQuickFilterWrapper.propTypes = {
  gridRef: PropTypes.object,
  gridRefs: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.any
}

export default function AGGridQuickFilterWrapper({ gridRef, gridRefs, children }) {
  const [searchValue, setSearchValue] = useState("");

  const allRefs = useMemo(() => {
    if (Array.isArray(gridRefs)) return gridRefs;
    if (gridRef) return [gridRef];
    return [];
  }, [gridRefs, gridRef]);

  useEffect(() => {
    allRefs.forEach((ref) => {
      ref?.current?.api?.setGridOption("quickFilterText", searchValue);
    });
  }, [searchValue, allRefs]);

  const clearAllFilters = () => {
    setSearchValue("");
    allRefs.forEach((ref) => {
      ref?.current?.api?.setFilterModel({});
    });
  }

  return (<Box sx={{ mb: 1 }}>
      <Grid container justifyContent="space-between" sx={{ mb: 1, pl: 2, pr: 2 }} spacing={2} >
        <Grid item sx={{ marginTop: "auto", minWidth: { xs: '100%', md: null }, mt: { xs: 2, md: null } }}>
          <Grid container direction="row" spacing={2} sx={{ minWidth: { xs: '100%', md: null } }}>
            {Array.isArray(children) ? children.filter(child => child)
              .map((child, index) => <Grid sx={{ minWidth: { xs: '100%', md: null }, display: "flex" }} item key={index}>{child}</Grid>) :
              <Grid sx={{ minWidth: { xs: '100%', md: null }, display: "flex" }} item>{children}</Grid>}
          </Grid>
        </Grid>
        <Grid item sx={{ marginTop: "auto", minWidth: { xs: '100%', md: 250 } }}>
          <TextField
            name="quickFilterText"
            size="small"
            placeholder="Filter"
            value={searchValue}
            sx={{ marginTop: "auto", width: '100%' }}
            inputProps={{ sx: { height: 15 } }}
            InputProps={{
              endAdornment: <InputAdornment position="end">
                {searchValue ? <Close sx={{ cursor: "pointer" }} onClick={() => setSearchValue("")} /> : <SearchSharp />}
              </InputAdornment>,
              startAdornment: <InputAdornment position="start">
                <FilterListOff onClick={clearAllFilters} sx={{ cursor: "pointer" }} />
              </InputAdornment>
            }}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>);
}
